import { cn } from '@/lib/utils'

/**
 * An agency's English name with its Japanese name under it (plans/09 AC-09.15). Each line truncates and carries its
 * full text in `title`, so the 135-character AG-1 name never overflows a row. Give `className` a max width where the
 * parent does not bound it (a table cell grows with its content). `wrap` lets both lines wrap instead (detail panels,
 * where the full name is the point).
 */
export function AgencyName({
  name,
  nameJa,
  wrap = false,
  className,
  nameClassName,
}: {
  name: string
  nameJa?: string | null
  wrap?: boolean
  className?: string
  nameClassName?: string
}) {
  const line = wrap ? 'break-words' : 'truncate'
  return (
    <span className={cn('block min-w-0', className)}>
      <span className={cn('block', line, nameClassName)} title={wrap ? undefined : name}>
        {name}
      </span>
      {nameJa && (
        <span lang='ja' className={cn('block text-xs text-muted-foreground', line)} title={wrap ? undefined : nameJa}>
          {nameJa}
        </span>
      )}
    </span>
  )
}
